// src/pages/Home.js
import React from 'react';
import logo from '../logo.svg';

function Home() {
    return (

        <div>

            <img src={logo} className="App-logo" alt="logo" />
            <h2>Home Page</h2>
            <p>Welcome to the Home Page!</p>

        </div>
    );
}

export default Home;